export default {
  Types: [
    { Id: 8, Text: 'enum.IssueType.MoveToWeb', Parent: true },
  ],
};
